unit uCards;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, WEBLib.Grids, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.Controls,
  WEBLib.DBCtrls, WEBLib.Buttons, Vcl.Imaging.pngimage, WEBLib.WebCtrls,
  WEBLib.ExtCtrls, WEBLib.REST, Data.DB, WEBLib.DB, WEBLib.CDS,
  Vcl.Imaging.GIFImg;

type
  TCards = class(TForm)
    WebRespGrid: TResponsiveGrid;
    WebMessageDlg1: TMessageDlg;
    WebPanel1: TPanel;
    WebPanel2: TPanel;
    WebLabel4: TLabel;
    NPages: TDBEdit;
    NXT: TBitBtn;
    PRV: TBitBtn;
    Page: TEdit;
    WebLabel3: TLabel;
    btnPrint: TBitBtn;
    btnOpen: TBitBtn;
    WebLabel1: TLabel;
    WebConnPages: TClientConnection;
    WebDSPages: TClientDataSet;
    WebDSPagesnpages: TIntegerField;
    WebDTSPages: TDataSource;
    RPP: TComboBox;
    lRPP: TLabel;
    Msg01: TMessageDlg;
    htmTeste: TMemo;
    upProdutos: THttpRequest;
    LayOut: TComboBox;
    WebLabel2: TLabel;
    procedure WebFormCreate(Sender: TObject);
    procedure btnOpenClick(Sender: TObject);
    procedure btnPrintClick(Sender: TObject);
    procedure WebRespGridItemGetFieldValue(Sender: TObject;
      Index: Integer; AFieldName: string; var AValue: string);
    procedure WebCheckBox1Click(Sender: TObject);
    procedure WebRespGridItemCreated(Sender: TObject; Index: Integer);
    procedure ButtonClick(Sender: TObject);
    procedure PageKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure PRVClick(Sender: TObject);
    procedure NXTClick(Sender: TObject);
    procedure RPPChange(Sender: TObject);
    procedure btnOpenMouseEnter(Sender: TObject);
    procedure btnOpenMouseLeave(Sender: TObject);
    procedure btnPrintMouseEnter(Sender: TObject);
    procedure btnPrintMouseLeave(Sender: TObject);
    procedure WebRespGridItemDblClick(Sender: TObject; Index: Integer);
    procedure WebConnPagesAfterConnect(Sender: TObject);
    procedure WebLabel2DblClick(Sender: TObject);
    procedure WebRespGridHttpRequestSuccess(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }

    cItens,               //Contador de Itens da Tabela no Banco de Dados
    cROWS,                //Contador de Linhas
    qCardsROW,            //Quantidade de Cards dentro da linha da Tabela HTML
    qLinesPage: integer;  //Quantidade de Cards dentro da linha da Tabela HTML

    vItens,           //Concatenação Geral dos itens em HTML
    xCards,           //Onde é multiplicado o HTML com base na quantidade de etiquetas em IdMain
    xS,               //Prefixo do LayOut de FastReport "1" para ser ex: s11, s12, s13 (Muda de Objeto no CSS)
    xBorders:         //Ativa Borda do Card
    string;
    //procedure LoadItens;
  protected procedure LoadDFMValues; override; end;

var
  Cards: TCards;

  const
  IDT1 = #9;
  IDT2 = #9+#9;
  IDT3 = #9+#9+#9;
  IDT4 = #9+#9+#9+#9;
  IDT5 = #9+#9+#9+#9+#9;
  IDT6 = #9+#9+#9+#9+#9+#9;

implementation

{$R *.dfm}
uses
  web, uFrmMain;

procedure TCards.btnPrintMouseEnter(Sender: TObject);
begin
    if btnPrint.Enabled  then
    begin
      btnPrint.Color:= clIndianred;
    end;
end;

procedure TCards.btnPrintMouseLeave(Sender: TObject);
begin
    btnPrint.Color:= clSkyBlue;
end;

procedure TCards.btnOpenClick(Sender: TObject);
var
  xLinhasPagina, xOffset: integer;
  xURL: string;
begin

    if FrmMain.xIdUdV = 0 then
    begin
        ShowMessage('Selecione ao menos uma data !');
        exit;
    end;

    //Não funciona
    //sleep(10000);
    
    //Zera Variáveis para reiniciar
    cItens      := 0;   //Contador dos Itens
    cROWS       := 0;   //Contador de Linhas na Página
    qCardsROW   := 0;   //Zera contador de Cards por Linha
        
    vItens      := '';  //HTML dos Itens


    case LayOut.ItemIndex of
        0:begin
        //Etiqueta    *Nome   Medida        *Nome = Definido na própria Impressora Elgin L42 PRO FULL
        //5cm x 3cm - 4 x 6 (101.6 mm 159.0 mm)
            qCardsROW               := 2;     //Etiquetas por Linha
            qLinesPage              := 5;     //Linhas por Página
            WebRespGrid.WidthPercent:= 50;
            xS                      := '';    //Prefixo do LayOut de FastReport "1" para ser ex: s11, s12, s13 (Muda de Objeto no CSS)
        end;
        1:begin
        //Etiqueta    *Nome   Medida        *Nome = Definido na própria Impressora Elgin L42 PRO FULL
        //5cm x 4cm - USER (106 mm 174 mm)
            qCardsROW               := 2;     //Etiquetas por Linha
            qLinesPage              := 4;     //Linhas por Página Altura de 169mm e gap de 3mm (Altura Card = 40mm * 4 linhas + 12)
            WebRespGrid.WidthPercent:= 50;
            xS                      := '';    //Prefixo do LayOut de FastReport "1" para ser ex: s11, s12, s13 (Muda de Objeto no CSS)
        end;
        2:begin
        //Etiqueta    *Nome   Medida
        //5cm x 2.5cm - USER (84 mm 164 mm) OK
            qCardsROW               := 2;     //Etiquetas por Linha
            qLinesPage              := 6;     //Linhas por Página Altura de 159mm + 5mm = 164mm *** Medida exata entre as etiquetas ***
            WebRespGrid.WidthPercent:= 50;
            xS                      := '';    //Prefixo do LayOut de FastReport "1" para ser ex: s11, s12, s13 (Muda de Objeto no CSS)
        end;
        3:begin
        //Etiqueta    *Nome   Medida        *Nome = Definido na própria Impressora Elgin L42 PRO FULL
        //5cm x 2.5cm - A4 (210 mm 297 mm)  8.3 x 11.7 in
        //5cm x 2.5cm - A5 size	148 x 210 mm	5.8 x 8.3 in
            qCardsROW               := 4;     //Etiquetas por Linha
            qLinesPage              := 10;    //Linhas por Página
            WebRespGrid.WidthPercent:= 95;
            xS                      := '1';   //Prefixo do LayOut de FastReport "" para ser ex: s1, s2, s3 (Muda de Objeto no CSS)
        end;
    end;

    xLinhasPagina := StrToInt(RPP.Text);

//    //Contador de Páginas
//    if WebConnPages.Active = false then
//    begin
//        try
//          WebConnPages.Active:= false;
//
//          //Quantidade de Páginas {considerando apenas curso > 0 e xLinhasPagina = 100)}
//          //BaseURL := 'produtos/npages?fetch='+IntToStr(xLinhasPagina)+'&idmain=>0';
//          //BaseURL := 'produtos/npages?fetch='+IntToStr(xLinhasPagina)+'&idmain=>0';
//          //xURL:= FrmMain.BaseURL + 'produtos/npages?fetch='+IntToStr(xLinhasPagina)+'&idmain=>0';
//          xURL:= FrmMain.BaseURL + 'produtos/prod_cards?idudv=4';
//
//          WebConnPages.URI:= xURL;
//
//          WebConnPages.Active:= true;
//
//        finally
//
//        end;
//    end;


    xOffset       :=  (StrToInt(Page.Text)-1) * xLinhasPagina;  //Posição do primeiro registro no banco de dados

    //Todos os Itens de Uma vez somente (Esta sequência não afeta o HTML do Item)
    //Cards
    WebRespGrid.Options.ItemTemplate :=
    '<b>Produto: (%produto%)</b><br>'+
    '<b>Desenho: (%desenho%)</b><br>'+
    //'<b>Desenho: R$ (%desenho%)</b><br>'+
    '<b>Descrição: <b><span>(%descr%)</span><br>'+
    '<br>';


    //'<b>Nº Etiquetas: (%idmain%)</b><br>';
    //+ '<img src="https://download.tmssoftware.com/tmsweb/demos/tmsweb_responsivegrid/img/(%Picture%)"><br>';

    //Verifica os Limites da Página considerando Curso > 0 e xLinhasPagina = 100
    //WebRespGrid.LoadFromJson(FrmMain.BaseURL + 'produtos?offset='+IntToStr(xOffset)+'&fetch='+IntToStr(xLinhasPagina)+ '&idmain=>0', 'data');
    WebRespGrid.LoadFromJson(FrmMain.BaseURL + 'produtos/prod_cards?idudv=' + IntToStr(FrmMain.xIdUdV), 'data');


end;

procedure TCards.btnOpenMouseEnter(Sender: TObject);
begin
    if btnOpen.Enabled  then
    begin
      btnOpen.Color:= clIndianred;
    end;
end;

procedure TCards.btnOpenMouseLeave(Sender: TObject);
begin
      btnOpen.Color:= clSkyBlue;
end;

procedure TCards.ButtonClick(Sender: TObject);
var
  el: TJSHTMLElement;
begin
  if Sender is TButton then
  begin
    el := TJSHTMLElement(WebRespGrid.Items[(Sender as TButton).Tag].ElementHandle.firstChild);
    MessageDlg('Adicionar ? :' + el.innerHTML, mtInformation, [mbOK]);
  end;
end;

procedure TCards.NXTClick(Sender: TObject);
begin
    if Page.Text <> '' then
    begin
        if StrToInt(Page.Text)<StrToInt(NPages.Text) then
        begin
            Page.Text:= IntToStr(StrToInt(Page.Text)+1);
            btnOpenClick(Self);  //Somente quando existe mudanças
        end;

    end else begin
        Page.Text:= NPages.Text;
        btnOpenClick(Self);  //Somente quando existe mudanças
    end;
    Page.SelectAll;
end;

procedure TCards.PageKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
begin
        if (Key = VK_F2) or (Key = VK_F3) or (Key= VK_RETURN) then Begin

            if NPages.Text = '' then
            begin
            //Sem NPages (Até 10 páginas)
                if StrToInt(Page.Text)>=10 then
                begin
                    Page.Text:= '10';
                end;
            end else begin
            //Com NPages (Verifica limites)
                if StrToInt(Page.Text)>StrToInt(NPages.Text) then
                begin
                    Page.Text:= NPages.Text;
                end;

                if StrToInt(Page.Text)<1 then
                begin
                    Page.Text:= '1';
                end;
            end;

            Page.SelectAll;
            Page.SetFocus;

            //  Pesquisa Dados
            btnOpenClick(Self);
        End;
end;

procedure TCards.PRVClick(Sender: TObject);
begin
    if Page.Text <> '' then
    begin
        if StrToInt(Page.Text)>=2 then
        begin
            Page.Text:= IntToStr(StrToInt(Page.Text)-1);
            btnOpenClick(Self);  //Somente quando existe mudanças
        end;

    end else begin
        Page.Text:= '1';
        btnOpenClick(Self);  //Somente quando existe mudanças
    end;
    Page.SelectAll;
end;

procedure TCards.RPPChange(Sender: TObject);
begin
    WebConnPages.Active:= false;  //Encerra Pages

    Page.Text := '1';
    //  Pesquisa Dados
    btnOpenClick(Self);
end;


procedure TCards.WebCheckBox1Click(Sender: TObject);
begin
  //if WebCheckBox1.Checked then
  //  WebResponsiveGrid1.HeightStyle := ssAbsolute
  //else
  //  WebResponsiveGrid1.HeightStyle := ssAuto;
end;

procedure TCards.WebConnPagesAfterConnect(Sender: TObject);
begin
      if WebDSPages.FieldByName('npages').AsString <> '0' then
      begin
          btnPrint.Enabled:= true;
      end else begin
          btnPrint.Enabled:= false;
      end;
end;

procedure TCards.WebFormCreate(Sender: TObject);
begin
  WebRespGrid.Options.ItemBorderColor := clSilver;
  WebRespGrid.Options.ItemHoverColor := $E1FFFF;
  WebRespGrid.Options.ItemHoverBorderColor := clGray;

  WebRespGrid.Options.ItemSelectedBorderColor := clAqua;
  WebRespGrid.Options.ItemSelectedColor := clBlue;
  WebRespGrid.Options.ItemSelectedTextColor := clWhite;
end;

procedure TCards.WebLabel2DblClick(Sender: TObject);
begin
    htmTeste.Visible:= not htmTeste.Visible;
end;

procedure TCards.WebRespGridHttpRequestSuccess(Sender: TObject);
begin
      //Limpa Cards para multiplicar HTML de Itens com base em IdMain
      xCards:= '';
end;

procedure TCards.WebRespGridItemCreated(Sender: TObject; Index: Integer);
//var
//  btn: TButton;
//begin
  {btn := TButton.Create(Self);
  btn.ParentElement := WebResponsiveGrid1.items[index].ElementHandle;
  btn.Caption := 'Comprar';
  btn.OnClick := ButtonClick;
  btn.Tag := Index;}

begin
    //xCards:= xCards + '<!-- xxxx -->'+Char(VK_RETURN);

    inc(cItens); //Incrementa Itens
end;

procedure TCards.WebRespGridItemDblClick(Sender: TObject;
  Index: Integer);

  procedure Afterdialog(Value: TModalResult);
  begin
    if Value = mrYes then
    begin

          if Value = mrYes then
          begin

              //Limpar todas as marcações
              //Cabeçalho do HTML
              //upProdutos.URL := 'produtos/zidmain?idmain=0';
              upProdutos.URL := FrmMain.BaseURL + 'produtos/zidmain?idmain=0';
              upProdutos.Command := httpPOST;
              upProdutos.Headers.Clear;
              upProdutos.Headers.AddPair('Content-Type','application/json');
              upProdutos.Headers.AddPair('Accept','application/json, text/plain, */*');
              upProdutos.PostData := '{"idmain": 0}';
              upProdutos.Execute();

          end;

    end;

  end;

begin
  WebMessageDlg1.ShowDialog('Deseja desmarcar esta etiqueta ?', mtConfirmation, [mbYes, mbNo], @AfterDialog);

end;

procedure TCards.btnPrintClick(Sender: TObject);

    procedure Afterdialog(Value: TModalResult);
    var
      xTitle, xInicio, xFim, xOutLine, xCards, xGapTopCard, xFonteSpan01,

      xLarguraPapel, xLarguraCard, xAlturaLinha, xAlturaCard, xAlturaMemo1, xMargemT, xMargemL, xGapH, xGapV     //Parâmetros da Etiqueta
      : string;
    begin

          if Value = mrYes then
          begin


              //Processamento por HTML
              //Título

              //https://paper-size.com/c/a-paper-sizes.html#google_vignette
              case LayOut.ItemIndex of
                  0:begin
                  //2- Etiquetas por linha L50mm x L30mm - Rolo (106 x 164)

                      xTitle:= '<title>2 Etiquetas por linha Rolo Térmico (Cards)</title>';

                      xBorders        := '/* border: solid 1px #000;  Borda do Card */';

                      //xLarguraPapel =  qCardsROW * xLarguraCard + (qCardsROW -1) * xGapH
                      //xLarguraPapel =  2 * 266 + (2-1) * 60
                      xLarguraPapel   := 'width: 592px; /* Largura do Papel */';

                      xLarguraCard    := 'width: 266px; /* Largura da etiqueta */';
                      xAlturaLinha    := 'height: 168px; /* Altura da Linha */';
                      xAlturaCard     := 'height: 150px; /* Altura do Linha */';
                      xGapTopCard     := 'height: 1px; /* Espaço no topo do Card */';
                      xAlturaMemo1    := 'height: 46px; /* Altura do Memo */';
                      xFonteSpan01    := 'font-size: 12px;';

                      xMargemT        := 'padding-top: 6px; /* Margem Top */';
                      xMargemL        := 'padding-left: 4px; /* Margem Left */';
                      xGapH           := 'width: 60px; /* Gap Cards Horizontal */';
                      xGapV           := 'height: 10px; /* Gap Cards Vertical */';

                  end;
                  1:begin
                  //2- Etiquetas por linha L50mm x L40mm - Rolo - USER (106.0 mm 164 mm)



                      xTitle:= '<title>2 Etiquetas por linha Rolo Térmico (Cards)</title>';

                      xBorders        := '/* border: solid 1px #000;  Borda do Card */';

                      //xLarguraPapel =  qCardsROW * xLarguraCard + (qCardsROW -1) * xGapH
                      //xLarguraPapel =  2 * 220 + (2-1) * 20
                      xLarguraPapel   := 'width: 582px; /* Largura do Papel */';

                      xLarguraCard    := 'width: 266px; /* Largura da etiqueta */';
                      xAlturaCard     := 'height: 216px; /* Altura do Linha */';
                      xAlturaLinha    := 'height: 218px; /* Altura do Linha */';

                      xGapTopCard     := 'height: 16px; /* Espaço no topo do Card */';
                      xAlturaMemo1    := 'height: 66px; /* Altura do Memo */';
                      xFonteSpan01    := 'font-size: 14px; line-height: 12px;';

                      xMargemT        := 'padding-top: 10px; /* Margem Top */';
                      xMargemL        := 'padding-left: 10px; /* Margem Left */';
                      xGapH           := 'width: 50px; /* Gap Cards Horizontal */';
                      xGapV           := 'height: 10px; /* Gap Cards Vertical */';

                  end;
                  2:begin
                  //2- Etiquetas por linha L50mm x L40mm - Rolo - USER (84.0 mm 164 mm) OK

                      xTitle:= '<title>2 Etiquetas por linha Rolo Térmico (Cards)</title>';

                      xBorders        := '/* border: solid 1px #000;  Borda do Card */';

                      //xLarguraPapel =  qCardsROW * xLarguraCard + (qCardsROW -1) * xGapH
                      //xLarguraPapel =  2 * 220 + (2-1) * 20
                      xLarguraPapel   := 'width: 480px; /* Largura do Papel */';

                      xLarguraCard    := 'width: 220px; /* Largura da etiqueta */';
                      xAlturaCard     := 'height: 124px; /* Altura do Linha */';
                      xAlturaLinha    := 'height: 128px; /* Altura do Linha */';

                      xGapTopCard     := 'height: 16px; /* Espaço no topo do Card */';
                      xAlturaMemo1    := 'height: 45px; /* Altura do Memo */';
                      xFonteSpan01    := 'font-size: 12px; line-height: 10px;';

                      xMargemT        := 'padding-top: 6px; /* Margem Top */';
                      xMargemL        := 'padding-left: 10px; /* Margem Left */';
                      xGapH           := 'width: 50px; /* Gap Cards Horizontal */';
                      xGapV           := 'height: 20px; /* Gap Cards Vertical */';

                  end;
                  3:begin
                  //4- Etiquetas por linha- A4 (279 x 280)


                      //1 mm	3.7795275591 pixel (X)
                      //        Millimeters   inches
                      //A4 size	210 x 297 mm	8.3 x 11.7 in
                      //A5 size	148 x 210 mm	5.8 x 8.3 in

                      xTitle:= '<title>4 Etiquetas por linha A4 (Cards)</title>';

                      xBorders        := 'border: solid 1px #000; /* Borda do Card */';

                      //xLarguraPapel =  qCardsROW
                      //xLarguraPapel =  2 *
                      xLarguraPapel   := 'width: 1222px; /* Largura do Papel */';

                      xLarguraCard    := 'width: 270px; /* Largura do Card */';
                      xAlturaLinha    := 'height: 160px; /* Altura do Linha */';
                      xAlturaCard     := 'height: 150px; /* Altura do Linha */';
                      xGapTopCard     := 'height: 1px; /* Espaço no topo do Card */';
                      xAlturaMemo1    := 'height: 120px; /* Altura do Memo */';
                      xFonteSpan01    := 'font-size: 12px; line-height: 10px;';

                      xMargemT        := 'padding-top: 40px; /* Margem Top */';
                      xMargemL        := 'padding-left: 70px; /* Margem Left */';
                      xGapH           := 'width: 30px; /* Gap Cards Horizontal */';
                      xGapV           := 'height: 10px; /* Gap Cards Vertical */';

                  end;
              end;

              //Cabeçalho do HTML com TABLE
              xInicio:= '<!DOCTYPE html>'+Char(VK_RETURN)+
              '<html lang="en">'+Char(VK_RETURN)+
              '<head>'+Char(VK_RETURN)+
              IDT1 + '<meta charset="utf-8">'+Char(VK_RETURN)+
              IDT1 + '<meta name="viewport" content="width=device-width, initial-scale=1.0">'+Char(VK_RETURN)+
              IDT1 + '<meta http-equiv="X-UA-Compatible" content="ie=edge">'+Char(VK_RETURN)+
              IDT1 + xTitle +Char(VK_RETURN)+
              IDT1 + '<link href="https://fonts.googleapis.com/css?family=Varela+Round" rel="stylesheet"/>'+Char(VK_RETURN)+
              IDT1 + '<!--link rel="stylesheet" href="stylex.css"-->'+Char(VK_RETURN)+
              IDT1 + '<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">'+Char(VK_RETURN)+
              IDT1 + '<link href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" rel="stylesheet"'+Char(VK_RETURN)+
              IDT2+ 'integrity="sha384-wvfXpqpZZVQGK6TAh5PVlGOfQNHSoD2xbE+QkPxCAFlNEevoEH3Sl0sibVcOQVnN" crossorigin="anonymous">'+Char(VK_RETURN)+
              Char(VK_RETURN)+
              IDT1 + '<!-- Script de Código de Barras -->'+Char(VK_RETURN)+
              IDT1 + '<script src="assets/dist/JsBarcode.all.js"></script>'+Char(VK_RETURN)+
              IDT1 + '<script>'+Char(VK_RETURN)+
              IDT2 + 'Number.prototype.zeroPadding = function(){'+Char(VK_RETURN)+
              IDT3 + 'var ret = "" + this.valueOf();'+Char(VK_RETURN)+
              IDT3 + 'return ret.length == 1 ? "0" + ret : ret;'+Char(VK_RETURN)+
              IDT2 + '};'+Char(VK_RETURN)+
              IDT1 + '</script>'+Char(VK_RETURN)+
              Char(VK_RETURN)+
              IDT1 + '<style type="text/css">'+Char(VK_RETURN)+
              IDT1 + '#container {'+Char(VK_RETURN)+
              IDT2 + xLarguraPapel+Char(VK_RETURN)+
              IDT2 + '/*border: solid 1px #000;*/'+Char(VK_RETURN)+
              IDT2 + 'display: -webkit-flex;'+Char(VK_RETURN)+
              IDT2 + 'display: -ms-flexbox;'+Char(VK_RETURN)+
              IDT2 + 'display: flex;'+Char(VK_RETURN)+
              IDT1 + '}'+Char(VK_RETURN)+
              IDT1 + '#master {'+Char(VK_RETURN)+
              IDT2 + xMargemT +Char(VK_RETURN)+
              IDT2 + xMargemL +Char(VK_RETURN)+
              IDT1 + '}'+Char(VK_RETURN)+
              IDT1 + '#a {'+Char(VK_RETURN)+
              IDT2 + xAlturaLinha +Char(VK_RETURN)+
              IDT2 + xLarguraCard +Char(VK_RETURN)+
              IDT2 + xBorders+Char(VK_RETURN)+
              IDT2 + 'border-radius: 4px;'+Char(VK_RETURN)+
              IDT2 + 'padding: 2px 2px;'+Char(VK_RETURN)+
              IDT1 + '}'+Char(VK_RETURN)+
              IDT1 + '#gapH {'+Char(VK_RETURN)+
              IDT2 + xGapH +Char(VK_RETURN)+
              IDT2 + '/*border: solid 1px #000;*/'+Char(VK_RETURN)+
              IDT1 + '}'+Char(VK_RETURN)+
              IDT1 + '#gapV {'+Char(VK_RETURN)+
              IDT2 + xGapV +Char(VK_RETURN)+
              IDT1 + '}'+Char(VK_RETURN)+
              IDT1 + '#gapTopCard {'+Char(VK_RETURN)+
              IDT2 + xGapTopCard +Char(VK_RETURN)+
              IDT1 + '}'+Char(VK_RETURN)+
              IDT1 + '#c {'+Char(VK_RETURN)+
              IDT2 + xLarguraCard +Char(VK_RETURN)+
              IDT2 + xBorders+Char(VK_RETURN)+
              IDT2 + 'border-radius: 4px;'+Char(VK_RETURN)+
              IDT2 + 'padding: 2px 2px;'+Char(VK_RETURN)+
              IDT1 + '}'+Char(VK_RETURN)+
              IDT1 + '#b01 {'+Char(VK_RETURN)+
              IDT2 + 'font-family: Helvetica;'+Char(VK_RETURN)+
              IDT2 + 'font-size: 15px;'+Char(VK_RETURN)+
              IDT2 + 'color: #000000; font-weight: bold; font-style: normal;'+Char(VK_RETURN)+
              IDT2 + 'text-align: Center; vertical-align: Top;'+Char(VK_RETURN)+
              IDT1 + '}'+Char(VK_RETURN)+

              IDT1 + '#card01 {'+Char(VK_RETURN)+
              IDT2 + xAlturaCard+Char(VK_RETURN)+
              IDT1 + '}'+Char(VK_RETURN)+

              IDT1 + '#span01 {'+Char(VK_RETURN)+
              IDT2 + 'font-family: Helvetica;'+Char(VK_RETURN)+
              IDT2 + xFonteSpan01+Char(VK_RETURN)+
              IDT2 + 'color: #000000; font-weight: bold; font-style: normal;'+Char(VK_RETURN)+
              IDT2 + xAlturaMemo1+Char(VK_RETURN)+
              IDT1 + '}'+Char(VK_RETURN)+
              IDT1 + '#span02 {'+Char(VK_RETURN)+
              IDT2 + 'font-family: Helvetica;'+Char(VK_RETURN)+
              IDT2 + 'font-size: 14px;'+Char(VK_RETURN)+
              IDT2 + 'color: #000000; font-weight: bold; font-style: normal;'+Char(VK_RETURN)+
              IDT2 + 'text-align: Left; vertical-align: Top;'+Char(VK_RETURN)+
              IDT2 + '/*height:190px;*/'+Char(VK_RETURN)+
              IDT1 + '}'+Char(VK_RETURN)+
              IDT1 + '.bar01 {'+Char(VK_RETURN)+
              IDT2 + xLarguraCard+Char(VK_RETURN)+
              IDT2 + 'padding-left: 0px;'+Char(VK_RETURN)+
              IDT2 + 'height: 62px;	/* Altura da DIV externamente do Barcode */'+Char(VK_RETURN)+
              IDT1 + '}'+Char(VK_RETURN)+
              IDT1 + '.page_break {page-break-before: always;}'+Char(VK_RETURN)+              
              IDT1 + '</style>'+Char(VK_RETURN)+
              Char(VK_RETURN)+
              '</head>'+Char(VK_RETURN)+
              '<body onload="window.print()">'+Char(VK_RETURN)+
              '<div id="master">'+Char(VK_RETURN)+
              Char(VK_RETURN);

              xCards:= vItens;

              //Final do HTML
              xFim:=
              //'</div>'+Char(VK_RETURN)+
              //'</div>'+Char(VK_RETURN)+
              '</body></html>';

              //Html completo para testes (Deixar ativo e cpiar após a impressão para testes)
              htmTeste.Text:= xInicio + vItens + xFim;

              //Javascript
              asm

                  //var divToPrint = document.getElementsByClassName('header_table')[0];
                  var anotherWindow = window.open('', 'Print-Window');
                  anotherWindow.document.open();
                  anotherWindow.document.write(
                  xInicio +

                  xCards +

                  xFim);
                  anotherWindow.document.close();

              end;

          end;
    end;


begin
  if WebRespGrid.Items.Count <> 0 then
  begin
      Msg01.ShowDialog('Deseja imprimir as etiquetas ?', mtConfirmation, [mbYes, mbNo], @AfterDialog);
  end else begin
      ShowMessage('Sem registros para o relatório .. !');
  end;
end;

procedure TCards.WebRespGridItemGetFieldValue(Sender: TObject;
  Index: Integer; AFieldName: string; var AValue: string);
var
  xLen: string;
begin
  {if AFieldName = 'Picture' then
  begin
    AVAlue := StringReplace(AValue, '.jpg', '_96.jpg', [rfReplaceAll]);
  end;}

   // 1- Código de Barras com Produto
  if AFieldName = 'produto' then
  begin
      //Decidido na prática
      xLen:= '40';
      if Length(Trim(AValue)) = 6 then
      begin
          xLen:= '33';
      end;

      if Length(Trim(AValue)) = 7 then
      begin
          xLen:= '44';
      end;

      if Length(Trim(AValue)) = 8 then
      begin
          xLen:= '55';
      end;

      if Length(Trim(AValue)) = 9 then
      begin
          xLen:= '60';
      end;

      if Length(Trim(AValue)) = 10 then
      begin
          xLen:= '67';
      end;

      //**************************************************************************
      //Verifica se é 0 começo da linha (8 mod 4 = 0), verificar antes de somar
      if cItens MOD qCardsROW = 0 then
      begin
         inc(cROWS);       //Contador de Linha
         vItens:= vItens +
         IDT1 + '<!-- Início da ROW -->'+Char(VK_RETURN)+
         IDT1 + '<div id="container">'+Char(VK_RETURN)+
         IDT2 + '<!-- Linha ' + IntToStr(cItens) + ' -->'+Char(VK_RETURN)+
         IDT2 + '<div id="a">'+
         Char(VK_RETURN);
      end else begin
         vItens:= vItens +
         IDT2 + '<!-- Linha ' + IntToStr(cItens) + ' -->'+Char(VK_RETURN)+
         IDT2 + '<div id="c">'+
         Char(VK_RETURN);
      end;


      //S:\ContFat\Disco00_Athenas\Projetos\TMS_Core\Projetos\EXITO\assets\reports\uCards_start.html
      vItens:= vItens +
      IDT3 + '<section class="card contact" id="card01">'+Char(VK_RETURN)+
      IDT3 + '<!--div class="icon">'+Char(VK_RETURN)+
      IDT3 + '<img src="assets/images/Chat.png" alt="Contact us.">'+Char(VK_RETURN)+
      IDT3 + '</div-->'+Char(VK_RETURN)+
      IDT3 + '<div id="gapTopCard"></div><!-- Gap Topo do Card -->'+Char(VK_RETURN)+
      IDT3 + '<div class="bar01">'+Char(VK_RETURN)+
      IDT3 + '<img id="idbar' + IntToStr(cItens) + '" width="200px"/>'+Char(VK_RETURN)+
      IDT3 + '<script>JsBarcode("#idbar' + IntToStr(cItens) + '", "' + AValue + '", {format: "CODE128", marginTop: -2, displayValue:false, height: ' + xLen + '});</script>'+Char(VK_RETURN)+
      IDT3 + '</div>'+Char(VK_RETURN)+
      IDT3 + '<span id="b01">' + AValue + '</span>'+Char(VK_RETURN);

      //Explicativo de algumas opções dentro de OPTIONS (Resolvi a posicão do Barcode com estas DICAS)
      // Option | Default value | Type |
      //--------|---------------|------|
      // [`format`](https://github.com/lindell/JsBarcode/wiki/Options#format) | `"auto" (CODE128)` | `String` |
      // [`width`](https://github.com/lindell/JsBarcode/wiki/Options#width) | `2` | `Number` |
      // [`height`](https://github.com/lindell/JsBarcode/wiki/Options#height) | `100` | `Number` |
      // [`displayValue`](https://github.com/lindell/JsBarcode/wiki/Options#display-value) | `true` | `Boolean` |
      // [`text`](https://github.com/lindell/JsBarcode/wiki/Options#text) | `undefined` | `String` |
      // [`fontOptions`](https://github.com/lindell/JsBarcode/wiki/Options#font-options) | `""` | `String` |
      // [`font`](https://github.com/lindell/JsBarcode/wiki/Options#font) | `"monospace"` | `String` |
      // [`textAlign`](https://github.com/lindell/JsBarcode/wiki/Options#text-align) | `"center"` | `String` |
      // [`textPosition`](https://github.com/lindell/JsBarcode/wiki/Options#text-position) | `"bottom"` | `String` |
      // [`textMargin`](https://github.com/lindell/JsBarcode/wiki/Options#text-margin) | `2` | `Number` |
      // [`fontSize`](https://github.com/lindell/JsBarcode/wiki/Options#font-size) | `20` | `Number` |
      // [`background`](https://github.com/lindell/JsBarcode/wiki/Options#background)  | `"#ffffff"` | `String (CSS color)` |
      // [`lineColor`](https://github.com/lindell/JsBarcode/wiki/Options#line-color) | `"#000000"` | `String (CSS color)` |
      // [`margin`](https://github.com/lindell/JsBarcode/wiki/Options#margins) | `10` | `Number` |
      // [`marginTop`](https://github.com/lindell/JsBarcode/wiki/Options#margins) | `undefined` | `Number` |
      // [`marginBottom`](https://github.com/lindell/JsBarcode/wiki/Options#margins) | `undefined` | `Number` |
      // [`marginLeft`](https://github.com/lindell/JsBarcode/wiki/Options#margins) | `undefined` | `Number` |
      // [`marginRight`](https://github.com/lindell/JsBarcode/wiki/Options#margins) | `undefined` | `Number` |
      // [`valid`](https://github.com/lindell/JsBarcode/wiki/Options#valid) | `function(valid){}` | `Function` |

  end;

  //3- Texto da Descrição do Produto
  if AFieldName = 'descr' then
  begin
      vItens:= vItens +
      IDT5 + '<span id="span01">' + AValue + '</span>'+Char(VK_RETURN);
  end;

  //4- Desenho do Produto
  if AFieldName = 'desenho' then
  begin

      vItens:= vItens +
      IDT5 + '<span id="span02">' + AValue + '</span>'+Char(VK_RETURN)+
      //IDT5 + '<!--button>Learn More</button-->'+Char(VK_RETURN)+
      IDT3 + '</section>'+Char(VK_RETURN)+
      IDT2 + '</div>'+Char(VK_RETURN)+
      Char(VK_RETURN)+
      IDT2 + '<div id="gapH"><!-- Gap Horizontal -->'+Char(VK_RETURN)+
      IDT2 + '</div>'+Char(VK_RETURN)+
      Char(VK_RETURN);


      //Última Coluna Finaliza com </div>
      if cItens MOD qCardsROW = (qCardsROW-1) then
      begin
          vItens:= vItens +
          IDT1 + '</div><!-- Final do container -->'+Char(VK_RETURN)+
          IDT1 + '<div id="gapV"></div><!-- Gap Horizontal Linha: ' + IntToStr(cROWS) + ' Cards/Page: ' + IntToStr(qLinesPage) + '-->'+Char(VK_RETURN);
          if cROWS = qLinesPage then begin
          //Com Page Break
              vItens:= vItens +
              IDT1 + '<div id="gapV" class="page_break"></div><!-- Gap Horizontal com Page Break Linha: ' + IntToStr(cROWS) + ' CArds/Page: ' + IntToStr(qLinesPage) + '-->'+Char(VK_RETURN);
              cROWS:= 0; //Reinicia
          end else begin

          end;

          //vItens:= vItens +
          //IDT1 + '</div>'+Char(VK_RETURN);
      end;

  end;



  // *** <tr style="height:10px"><td></td><td colspan="6" class="s' + xS + '3">AHRX36718</td><td></td><td></td><td colspan="6" class="s' + xS + '3">CKFL27551</td><td></td></tr> **
  // *** Cada LineTable[Vetor].Produto CONTERÁ os dados do HTML completo da Linga conforme exemplo acima (Com duas Linhas)
  // Mapa do Record LineTable[Vetor].Produto SOMENTE PARA UM REGISTRO (neste caso Produto)
  // cItens = 46 (Dado) Contador de Itens da Tabela no Banco de Dados
  // cROWS =  4 (Calc) Contador de Cards dentro da Linhas da Tabela HTML
  // qCardsROW =  4 (Dado) Máximo de Cards dentro da linha da Tabela HT
  // ----------------- Coordenada cCards ----------------->
  //| Vetor   |  MOD = 0 |  MOD = 1 |  MOD = 2 |  MOD = 3 |
  //| C    1  | cItens=0 | cItens=1 | cItens=2 | cItens=3 |  Começar contador com zero
  //| o    2  | cItens=4 | cItens=5 | cItens=6 | cItens=7 |
  //  o    3  | cItens=8 | cItens=9 | cItens=10| cItens=11|
  //| r    4  | cItens=12| cItens=13| cItens=14| cItens=15|
  //| d    5  | cItens=16| cItens=17| cItens=18| cItens=19|
  //| e    6  | cItens=20| cItens=21| cItens=22|          |
  //| n    7  |          |          |          |          |
  //| a    8  |          |          |          |          |
  //| d    9  |          |          |          |          |
  //| a   10  |          |          |          |          |
  //|     11  |          |          |          |          |
  //| c   12  | cItens=45| cItens=46|          |          |
  //| L       |          |          |          |          |
  //| i       |    M     |          |          |          |
  //| n       |    O     |          |          |          |
  //| h       |    D     |          |          |          |
  //| a       |    =     |          |          |          |
  //|         |    Z     |          |          |          |
  //|         |    E     |          |          |          |
  //|         |    R     |          |          |          |
  //|         |    0     |          |          |          |
  //|         |          |          |          |          |
  //| cCard = cItem MOD qCardsROW = 4
end;

procedure TCards.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebRespGrid := TResponsiveGrid.Create(Self);
  WebMessageDlg1 := TMessageDlg.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  lRPP := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  NPages := TDBEdit.Create(Self);
  NXT := TBitBtn.Create(Self);
  PRV := TBitBtn.Create(Self);
  Page := TEdit.Create(Self);
  btnPrint := TBitBtn.Create(Self);
  btnOpen := TBitBtn.Create(Self);
  RPP := TComboBox.Create(Self);
  LayOut := TComboBox.Create(Self);
  Msg01 := TMessageDlg.Create(Self);
  htmTeste := TMemo.Create(Self);
  WebConnPages := TClientConnection.Create(Self);
  WebDSPages := TClientDataSet.Create(Self);
  WebDSPagesnpages := TIntegerField.Create(Self);
  WebDTSPages := TDataSource.Create(Self);
  upProdutos := THttpRequest.Create(Self);

  WebRespGrid.BeforeLoadDFMValues;
  WebMessageDlg1.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  lRPP.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  NPages.BeforeLoadDFMValues;
  NXT.BeforeLoadDFMValues;
  PRV.BeforeLoadDFMValues;
  Page.BeforeLoadDFMValues;
  btnPrint.BeforeLoadDFMValues;
  btnOpen.BeforeLoadDFMValues;
  RPP.BeforeLoadDFMValues;
  LayOut.BeforeLoadDFMValues;
  Msg01.BeforeLoadDFMValues;
  htmTeste.BeforeLoadDFMValues;
  WebConnPages.BeforeLoadDFMValues;
  WebDSPages.BeforeLoadDFMValues;
  WebDSPagesnpages.BeforeLoadDFMValues;
  WebDTSPages.BeforeLoadDFMValues;
  upProdutos.BeforeLoadDFMValues;
  try
    Name := 'Cards';
    Width := 1000;
    Height := 848;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -13;
    Font.Name := 'Tahoma';
    Font.Style := [];
    FormContainer := 'appcontent';
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    WebRespGrid.SetParentComponent(Self);
    WebRespGrid.Name := 'WebRespGrid';
    WebRespGrid.Left := 700;
    WebRespGrid.Top := 105;
    WebRespGrid.Width := 300;
    WebRespGrid.Height := 743;
    WebRespGrid.ElementClassName := 'respgrid';
    WebRespGrid.HeightStyle := ssAuto;
    WebRespGrid.WidthStyle := ssPercent;
    WebRespGrid.WidthPercent := 95.000000000000000000;
    WebRespGrid.Align := alClient;
    WebRespGrid.ItemIndex := 0;
    WebRespGrid.Options.ItemClassName := 'respitem';
    WebRespGrid.Options.ItemHeight := 180;
    WebRespGrid.Options.ItemHoverColor := cl3DDkShadow;
    WebRespGrid.Options.ItemPadding := 20;
    WebRespGrid.Options.ItemWidthMin := 260;
    SetEvent(WebRespGrid, Self, 'OnItemCreated', 'WebRespGridItemCreated');
    SetEvent(WebRespGrid, Self, 'OnItemGetFieldValue', 'WebRespGridItemGetFieldValue');
    SetEvent(WebRespGrid, Self, 'OnItemDblClick', 'WebRespGridItemDblClick');
    SetEvent(WebRespGrid, Self, 'OnHttpRequestSuccess', 'WebRespGridHttpRequestSuccess');
    WebMessageDlg1.SetParentComponent(Self);
    WebMessageDlg1.Name := 'WebMessageDlg1';
    WebMessageDlg1.Left := 861;
    WebMessageDlg1.Top := 10;
    WebMessageDlg1.Width := 24;
    WebMessageDlg1.Height := 24;
    WebMessageDlg1.Buttons := [];
    WebMessageDlg1.Opacity := 0.200000000000000000;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 1000;
    WebPanel1.Height := 105;
    WebPanel1.Align := alTop;
    WebPanel1.BorderColor := clWhite;
    WebPanel1.ChildOrder := 9;
    WebPanel1.Color := clWhite;
    WebPanel1.TabOrder := 2;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 25;
    WebLabel1.Top := 29;
    WebLabel1.Width := 272;
    WebLabel1.Height := 39;
    WebLabel1.Caption := 'Visualizar etiquetas';
    WebLabel1.Color := 16711422;
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clBlack;
    WebLabel1.Font.Height := -32;
    WebLabel1.Font.Name := 'Tahoma';
    WebLabel1.Font.Style := [];
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 360;
    WebPanel2.Top := 0;
    WebPanel2.Width := 640;
    WebPanel2.Height := 105;
    WebPanel2.Align := alRight;
    WebPanel2.BorderColor := clWhite;
    WebPanel2.ChildOrder := 9;
    WebPanel2.Color := clWhite;
    WebPanel2.TabOrder := 0;
    WebLabel4.SetParentComponent(WebPanel2);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 395;
    WebLabel4.Top := 59;
    WebLabel4.Width := 49;
    WebLabel4.Height := 16;
    WebLabel4.Caption := 'P'#225'ginas:';
    WebLabel4.Color := 16711422;
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(WebPanel2);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 285;
    WebLabel3.Top := 59;
    WebLabel3.Width := 43;
    WebLabel3.Height := 16;
    WebLabel3.Caption := 'P'#225'gina:';
    WebLabel3.Color := 16711422;
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    lRPP.SetParentComponent(WebPanel2);
    lRPP.Name := 'lRPP';
    lRPP.Left := 0;
    lRPP.Top := 59;
    lRPP.Width := 34;
    lRPP.Height := 16;
    lRPP.Caption := 'R.P.P.';
    lRPP.Color := 16711422;
    lRPP.HeightPercent := 100.000000000000000000;
    lRPP.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(WebPanel2);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 0;
    WebLabel2.Top := 10;
    WebLabel2.Width := 100;
    WebLabel2.Height := 16;
    WebLabel2.Caption := 'LayOut Etiquetas:';
    WebLabel2.Color := 16711422;
    WebLabel2.Font.Charset := DEFAULT_CHARSET;
    WebLabel2.Font.Color := clBrown;
    WebLabel2.Font.Height := -13;
    WebLabel2.Font.Name := 'Tahoma';
    WebLabel2.Font.Style := [];
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.ParentFont := False;
    WebLabel2.WidthPercent := 100.000000000000000000;
    SetEvent(WebLabel2, Self, 'OnDblClick', 'WebLabel2DblClick');
    NPages.SetParentComponent(WebPanel2);
    NPages.Name := 'NPages';
    NPages.Left := 395;
    NPages.Top := 76;
    NPages.Width := 49;
    NPages.Height := 24;
    NPages.ChildOrder := 13;
    NPages.HeightPercent := 100.000000000000000000;
    NPages.Text := 'NPages';
    NPages.WidthPercent := 100.000000000000000000;
    NPages.DataField := 'npages';
    NPages.DataSource := WebDTSPages;
    NXT.SetParentComponent(WebPanel2);
    NXT.Name := 'NXT';
    NXT.Left := 365;
    NXT.Top := 75;
    NXT.Width := 24;
    NXT.Height := 25;
    NXT.Caption := '>';
    NXT.Color := clSkyBlue;
    NXT.ElementClassName := 'btn btn-light';
    NXT.ElementFont := efCSS;
    NXT.Font.Charset := ANSI_CHARSET;
    NXT.Font.Color := clWindowText;
    NXT.Font.Height := -13;
    NXT.Font.Name := 'Roboto';
    NXT.Font.Style := [];
    NXT.HeightStyle := ssAuto;
    NXT.HeightPercent := 100.000000000000000000;
    NXT.ParentFont := False;
    NXT.TabOrder := 3;
    NXT.WidthPercent := 100.000000000000000000;
    SetEvent(NXT, Self, 'OnClick', 'NXTClick');
    PRV.SetParentComponent(WebPanel2);
    PRV.Name := 'PRV';
    PRV.Left := 340;
    PRV.Top := 75;
    PRV.Width := 24;
    PRV.Height := 25;
    PRV.Caption := '<';
    PRV.Color := clSkyBlue;
    PRV.ElementClassName := 'btn btn-light';
    PRV.ElementFont := efCSS;
    PRV.Font.Charset := ANSI_CHARSET;
    PRV.Font.Color := clWindowText;
    PRV.Font.Height := -13;
    PRV.Font.Name := 'Roboto';
    PRV.Font.Style := [];
    PRV.HeightStyle := ssAuto;
    PRV.HeightPercent := 100.000000000000000000;
    PRV.ParentFont := False;
    PRV.TabOrder := 3;
    PRV.WidthPercent := 100.000000000000000000;
    SetEvent(PRV, Self, 'OnClick', 'PRVClick');
    Page.SetParentComponent(WebPanel2);
    Page.Name := 'Page';
    Page.Left := 285;
    Page.Top := 76;
    Page.Width := 49;
    Page.Height := 24;
    Page.ChildOrder := 6;
    Page.EditType := weNumeric;
    Page.HeightPercent := 100.000000000000000000;
    Page.Required := True;
    Page.TabOrder := 1;
    Page.Text := '1';
    Page.WidthPercent := 100.000000000000000000;
    SetEvent(Page, Self, 'OnKeyUp', 'PageKeyUp');
    btnPrint.SetParentComponent(WebPanel2);
    btnPrint.Name := 'btnPrint';
    btnPrint.Left := 175;
    btnPrint.Top := 74;
    btnPrint.Width := 102;
    btnPrint.Height := 25;
    btnPrint.Caption := 'Imprimir';
    btnPrint.Color := clSkyBlue;
    btnPrint.ElementClassName := 'btn btn-light';
    btnPrint.ElementFont := efCSS;
    btnPrint.Font.Charset := ANSI_CHARSET;
    btnPrint.Font.Color := clBlack;
    btnPrint.Font.Height := -13;
    btnPrint.Font.Name := 'Roboto';
    btnPrint.Font.Style := [];
    btnPrint.Glyph.LoadFromFile('uCards.WebPanel2.btnPrint.Glyph.png');
    btnPrint.HeightStyle := ssAuto;
    btnPrint.HeightPercent := 100.000000000000000000;
    btnPrint.ParentFont := False;
    btnPrint.TabOrder := 3;
    btnPrint.WidthPercent := 100.000000000000000000;
    SetEvent(btnPrint, Self, 'OnClick', 'btnPrintClick');
    SetEvent(btnPrint, Self, 'OnMouseLeave', 'btnPrintMouseLeave');
    SetEvent(btnPrint, Self, 'OnMouseEnter', 'btnPrintMouseEnter');
    btnOpen.SetParentComponent(WebPanel2);
    btnOpen.Name := 'btnOpen';
    btnOpen.Left := 61;
    btnOpen.Top := 74;
    btnOpen.Width := 102;
    btnOpen.Height := 25;
    btnOpen.Caption := 'Pesquisar';
    btnOpen.Color := clSkyBlue;
    btnOpen.ElementClassName := 'btn btn-light';
    btnOpen.ElementFont := efCSS;
    btnOpen.Font.Charset := ANSI_CHARSET;
    btnOpen.Font.Color := clBlack;
    btnOpen.Font.Height := -13;
    btnOpen.Font.Name := 'Roboto';
    btnOpen.Font.Style := [];
    btnOpen.Glyph.LoadFromFile('uCards.WebPanel2.btnOpen.Glyph.png');
    btnOpen.HeightStyle := ssAuto;
    btnOpen.HeightPercent := 100.000000000000000000;
    btnOpen.ParentFont := False;
    btnOpen.TabOrder := 3;
    btnOpen.WidthPercent := 100.000000000000000000;
    SetEvent(btnOpen, Self, 'OnClick', 'btnOpenClick');
    SetEvent(btnOpen, Self, 'OnMouseLeave', 'btnOpenMouseLeave');
    SetEvent(btnOpen, Self, 'OnMouseEnter', 'btnOpenMouseEnter');
    RPP.SetParentComponent(WebPanel2);
    RPP.Name := 'RPP';
    RPP.Left := 0;
    RPP.Top := 75;
    RPP.Width := 55;
    RPP.Height := 24;
    RPP.HeightPercent := 100.000000000000000000;
    RPP.Text := '160';
    RPP.WidthPercent := 100.000000000000000000;
    SetEvent(RPP, Self, 'OnChange', 'RPPChange');
    RPP.ItemIndex := 3;
    RPP.Items.BeginUpdate;
    try
      RPP.Items.Clear;
      RPP.Items.Add('4');
      RPP.Items.Add('40');
      RPP.Items.Add('80');
      RPP.Items.Add('160');
      RPP.Items.Add('240');
    finally
      RPP.Items.EndUpdate;
    end;
    LayOut.SetParentComponent(WebPanel2);
    LayOut.Name := 'LayOut';
    LayOut.Left := 0;
    LayOut.Top := 29;
    LayOut.Width := 279;
    LayOut.Height := 24;
    LayOut.HeightPercent := 100.000000000000000000;
    LayOut.Text := '2 Colunas - 5   Linhas - 5 X 3 (106 x 159)';
    LayOut.WidthPercent := 100.000000000000000000;
    SetEvent(LayOut, Self, 'OnChange', 'RPPChange');
    LayOut.ItemIndex := 0;
    LayOut.Items.BeginUpdate;
    try
      LayOut.Items.Clear;
      LayOut.Items.Add('2 Colunas - 5   Linhas - 5 X 3 (106 x 159)');
      LayOut.Items.Add('2 Colunas - 4   Linhas - 5 X 4 (106 x 164)');
      LayOut.Items.Add('2 Colunas - 6   Linhas - 4 X 2.5 (84 x 164)');
      LayOut.Items.Add('4 Colunas - 10 Linhas - 3 X 2.5 (279 x 280)');
      LayOut.Items.Add('1 Coluna  -  1   Linha - 10 X 15 (106 x 154)');
    finally
      LayOut.Items.EndUpdate;
    end;
    Msg01.SetParentComponent(Self);
    Msg01.Name := 'Msg01';
    Msg01.Left := 480;
    Msg01.Top := 44;
    Msg01.Width := 24;
    Msg01.Height := 24;
    Msg01.Buttons := [];
    Msg01.Opacity := 0.200000000000000000;
    htmTeste.SetParentComponent(Self);
    htmTeste.Name := 'htmTeste';
    htmTeste.Left := 0;
    htmTeste.Top := 105;
    htmTeste.Width := 700;
    htmTeste.Height := 743;
    htmTeste.Align := alLeft;
    htmTeste.HeightPercent := 100.000000000000000000;
    htmTeste.Lines.BeginUpdate;
    try
      htmTeste.Lines.Clear;
      htmTeste.Lines.Add('WebMemo1');
    finally
      htmTeste.Lines.EndUpdate;
    end;
    htmTeste.SelLength := 0;
    htmTeste.SelStart := 0;
    htmTeste.Visible := False;
    htmTeste.WidthPercent := 100.000000000000000000;
    WebConnPages.SetParentComponent(Self);
    WebConnPages.Name := 'WebConnPages';
    WebConnPages.Active := False;
    WebConnPages.DataNode := 'data';
    WebConnPages.Delimiter := ';';
    WebConnPages.AfterConnect := WebConnPagesAfterConnect;
    WebConnPages.Left := 868;
    WebConnPages.Top := 24;
    WebDSPages.SetParentComponent(Self);
    WebDSPages.Name := 'WebDSPages';
    WebDSPages.Connection := WebConnPages;
    WebDSPages.Left := 864;
    WebDSPages.Top := 88;
    WebDSPagesnpages.SetParentComponent(WebDSPages);
    WebDSPagesnpages.Name := 'WebDSPagesnpages';
    WebDSPagesnpages.FieldName := 'npages';
    WebDTSPages.SetParentComponent(Self);
    WebDTSPages.Name := 'WebDTSPages';
    WebDTSPages.DataSet := WebDSPages;
    WebDTSPages.Left := 864;
    WebDTSPages.Top := 152;
    upProdutos.SetParentComponent(Self);
    upProdutos.Name := 'upProdutos';
    upProdutos.Left := 859;
    upProdutos.Top := 233;
  finally
    WebRespGrid.AfterLoadDFMValues;
    WebMessageDlg1.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    lRPP.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    NPages.AfterLoadDFMValues;
    NXT.AfterLoadDFMValues;
    PRV.AfterLoadDFMValues;
    Page.AfterLoadDFMValues;
    btnPrint.AfterLoadDFMValues;
    btnOpen.AfterLoadDFMValues;
    RPP.AfterLoadDFMValues;
    LayOut.AfterLoadDFMValues;
    Msg01.AfterLoadDFMValues;
    htmTeste.AfterLoadDFMValues;
    WebConnPages.AfterLoadDFMValues;
    WebDSPages.AfterLoadDFMValues;
    WebDSPagesnpages.AfterLoadDFMValues;
    WebDTSPages.AfterLoadDFMValues;
    upProdutos.AfterLoadDFMValues;
  end;
end;

end.
